class userHelper {
  constructor (user) {
    this.userData = user.data.user
    this.userData.role = user.data.role
    this.userData.permissions = user.data.permissions
    this.userData.companyPermissions = user.data.companyPermissions
    this.userData.company = user.data.company
    this.userData.extension = user.data.extension
    this.userData.loginType = user.data.loginType
    this.userData.language = user.data.language
    this.userData.servers = user.data.servers
    this.userData.companyQueueStatuses = user.data.companyQueueStatuses

    this.accessToken = user.data.access_token
    this.refreshToken = user.data.refresh_token
  }

  getUserData () {
    return this.userData
  }

  getAccessToken () {
    return this.accessToken
  }
  getRefreshToken () {
    return this.refreshToken
  }

  getRedirectUrl () {
    // TODO: Find a better alternative for checking role.
    if (this.userData.role === 'admin') {
      return '/admin/dashboard'
    }

    if (this.userData.companyPermissions.includes('company_can_use_dashboard') === false) {
      return '/consultations/consultations'
    }

    if (this.userData.role === 'agent' && this.userData.permissions.includes('dashboard') === false) {
      return '/consultations/consultations'
    }

    if (this.userData.username === 'user') {
      return '/dashboard/announcements'
    }

    return '/dashboard'
  }
}

export default userHelper
